export default "__VITE_ASSET__D6TAeK4i__"